<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">{{ location }}</h2>
      <span>|</span>
      <h2 class="title title-primary">
        {{ $t("lang.online.box_detail.page_title_line_3") }}
      </h2>
      <span>|</span>
      <h3 class="title title-primary">
        &nbsp;|&nbsp;{{ $t("lang.online.box_detail.page_title_line_2") }}
      </h3>
    </div>
    <div class="page-header">
      <div class="boxes" v-if="!shouldLoading">
        <bx-box
          dark
          color="outline"
          :title="$t('lang.online.box_detail.box_title_1')"
          class="col-12 col-md-auto p-1"
        >
          <template slot="actions">
            <bx-reception-box-status :status="status" dark></bx-reception-box-status>
          </template>
          <div class="detail-titles">
            <div class="wrapper">
              <h4>
                <strong>{{ receptionBoxData.barcode }}</strong>
              </h4>
              <h5>
                <strong>{{ name }}</strong>
              </h5>
            </div>
          </div>
        </bx-box>

        <bx-box dark color="outline" class="col-6 col-md-auto p-1">
          <bx-value
            :label="$t('lang.online.box_detail.box_label_4')"
            :value="arrivalTime"
            font-size="xs"
          />
        </bx-box>

        <bx-box
          dark
          color="outline"
          class="col-6 col-md-auto p-1 bx-box-adjustable"
        >
          <bx-value
            :label="$t('lang.online.box_detail.box_label_3')"
            :value="
              `${receptionBoxData.real_item_count}/${receptionBoxData.theorical_item_count}`
            "
            font-size="sm"
          />
        </bx-box>
      </div>
      <skeleton-boxes :boxes="3" v-else />
    </div>

    <div class="page-main-content">
      <div class="container-fluid">
        <div class="row" style="margin: 8px">
          <bx-btn @click="$router.back()">{{
            $t("lang.messages.go_back")
          }}</bx-btn>
        </div>

        <div class="row">
          <div class="col-12">
            <bx-box
              :title="
                itemCount + ' ' + $t('lang.online.box_detail.table_title')
              "
              color="white"
              no-padding
              :loading="shouldLoading"
            >
              <template v-slot:default>
                <skeleton-table :columns="9" v-if="shouldLoading" />

                <bx-table
                  :data="data"
                  :columns="columns"
                  paginated
                  v-if="!shouldLoading"
                  backendPagination
                  :currentPage="page"
                  :perPage="itemsPerPage"
                  :total="itemCount"
                  @update:currentPage="updatePage"
                >
                  <template slot-scope="props">
                    <bx-table-column>
                      <router-link
                        :to="
                          `/movements/entry/order/${orderId}/gtin/${props.row.itemType}/detail`
                        "
                        class="bx-link bx-link-bold"
                        >{{ props.row.gtin }}</router-link
                      >
                    </bx-table-column>
                    <bx-table-column>{{
                      props.row.theorical_item_count
                    }}</bx-table-column>
                    <bx-table-column>{{
                      props.row.real_item_count
                    }}</bx-table-column>
                    <bx-table-column>{{ props.row.description }}</bx-table-column>
                    <bx-table-column>{{
                      props.row.cloth_type
                    }}</bx-table-column>
                    <bx-table-column>{{ props.row.model }}</bx-table-column>
                    <bx-table-column>{{ props.row.color }}</bx-table-column>
                    <bx-table-column>{{ props.row.size }}</bx-table-column>
                    <bx-table-column v-if="props.row.ratingPercent > 100">
                      <bx-complementary-mini
                        :percent="100"
                      ></bx-complementary-mini>
                    </bx-table-column>
                    <bx-table-column v-if="props.row.ratingPercent <= 100">
                      <bx-complementary-mini
                        :percent="props.row.ratingPercent"
                      ></bx-complementary-mini>
                    </bx-table-column>
                  </template>
                </bx-table>
              </template>
            </bx-box>
          </div>
        </div>
        <v-row class="d-flex d-sm-none">
          <v-list width="100%">
            <v-list-item
              two-line
              v-for="(item, index) in data"
              :key="index"
              class="green lighten-5 ma-2 rounded-lg"
              ripple
              :to="`/movements/entry/order/${orderId}/gtin/${item.itemType}/detail`">
              <v-list-item-content>
                <v-list-item-title>
                  <div>
                    {{ item.gtin }}
                  </div>
                </v-list-item-title>
                <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">{{
                  item.cloth_type
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-subtitle class="text-caption">
                  {{ item.real_item_count + "/" + item.theorical_item_count }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">
                  {{ item.color }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">
                  {{ item.model }}
                </v-list-item-subtitle>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import BxTable from "../../../bx-components/BxTable";
import BxTableColumn from "../../../bx-components/BxTableColumn";
import BxBtn from "../../../bx-components/BxBtn";
export default {
  name: "online-box-entry-detail",
  components: { BxBtn, BxTableColumn, BxTable },
  props: {
    id: {
      type: [Number, String]
    },
    orderId: {
      type: [Number, String]
    }
  },
  data() {
    return {
      shouldLoading: true,
      columns: [],
      data: [],
      receptionBoxData: null,
      receptionTime: "",
      waitingTime: "",
      itemCount: "",
      name: "",
      status: 0,
      contents: [],
      reloadInterval: null,
      API_BASE: process.env.VUE_APP_API_BASE,
      itemsPerPage: process.env.VUE_APP_GTIN_PER_PAGE,
      page: 1
    };
  },
  computed: {
    location() {
      return localStorage.getItem("location");
    }
  },
  methods: {
    updatePage(p) {
      this.page = p;
      this.getData(this.locationId);
    },
    async getData() {
      this.receptionBoxData = await this.$api.reception_boxes.get(this.id);
      this.arrivalTime = this.receptionBoxData.reading_time;
      this.status = this.receptionBoxData.status;
      this.waitingTime = this.receptionBoxData.waiting_time;
      this.name = this.receptionBoxData.order_name;
      this.report = await this.$api.reception_boxes.report(this.id);
      this.itemCount = this.report.length;
      this.data = this.report.map((item, key) => {
        return {
          gtin: item.gtin,
          itemType: item.item_type,
          theorical_item_count: item.theorical_item_count,
          real_item_count: item.real_item_count,
          cloth_type: item.cloth_type,
          id: item.id,
          size: item.size,
          color: item.colour,
          model: item.model,
          description: item.description,
          section: item.section,
          ratingPercent:
            (item.real_item_count / item.theorical_item_count) * 100
        };
      });

      this.columns = [
        {
          field: "gtin",
          label: this.$t("lang.online.box_detail.table_field_1")
        },
        {
          field: "theorical_item_count",
          label: this.$t("lang.online.box_detail.table_field_2")
        },
        {
          field: "real_item_count",
          label: this.$t("lang.online.box_detail.table_field_3")
        },
        {
          field: "description",
          label: this.$t("lang.online.box_detail.description")
        },
        {
          field: "itemtype",
          label: this.$t("lang.online.box_detail.table_field_5")
        },
        {
          field: "model",
          label: this.$t("lang.online.box_detail.table_field_6")
        },
        {
          field: "color",
          label: this.$t("lang.online.box_detail.table_field_7")
        },
        {
          field: "size",
          label: this.$t("lang.online.box_detail.table_field_8")
        },
        {
          field: "ratingPercent",
          label: this.$t("lang.online.box_detail.table_field_9"),
          width: 200
        }
      ];

      this.shouldLoading = false;
    }
  },
  mounted() {
    this.reloadInterval = setInterval(
      this.getData,
      process.env.VUE_APP_RELOAD_TIME
    );
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  }
};
</script>
<style scoped>
@media screen and (max-width: 480px) {
  .bx-box-adjustable >>> .bx-box-content {
    min-height: 95px;
  }

  .bx-box-adjustable >>> .bx-value-value {
    margin-top: 10px;
  }
}
</style>
